// API Configuration
const API_CONFIG = {
    development: {
        baseURL: process.env.VUE_APP_API_BASE_URL_LOCAL || '/api/walls'
    },
    production: {
        baseURL: process.env.VUE_APP_API_BASE_URL || '/api/walls'
    }
};

export const getApiUrl = () => {
    const environment = process.env.NODE_ENV || 'development';
    return API_CONFIG[environment].baseURL;
};

export default API_CONFIG;